import styled from "styled-components";

export const ButtonsBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
}));

export const BaggageButton = styled("button")(({ theme }) => ({
  width: "50%",
  backgroundColor: theme.palette.white,
  border: `1px solid ${theme.palette.borderDefault}`,
  borderRadius: 0,
  color: theme.palette.textPrimary,
  fontSize: 14,
  height: 32,
  cursor: "pointer",
  transition: "all .3s ease",

  "&.active": {
    backgroundColor: theme.palette.accent,
    borderColor: theme.palette.accent,
    color: theme.palette.white,
  }
}));
